import React from "react";
import styled from "@emotion/styled";
import { useFormContext } from "react-hook-form";
import InformationTranslation from "./InformationTranslation";
import { productInformationTextFields } from "@utils/productInformation";

const ProductInformationInput = ({ informationRef }: { informationRef?: React.Ref<HTMLDivElement> }) => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <Container ref={informationRef}>
      <Title>Product Information</Title>
      <InformationTranslation />
      <Description>선택 입력 항목입니다. 입력하지 않은 정보는 상품 상세에 '-'로 표시됩니다.</Description>
      <Field>
        <label htmlFor="product_moq">상품 MOQ (최소 주문 수량)</label>
        <Input
          id="product_moq" type="number" inputMode="numeric" min={1} step={1}
          placeholder="예: 2"
          {...register("product_moq", { setValueAs: (value) => value === "" || value == null ? null : Number(value) })}
        />
        {errors.product_moq && <Error role="alert">{errors.product_moq.message?.toString()}</Error>}
      </Field>
      {productInformationTextFields.filter(([name]) => name !== "origin_ja").map(([name, label]) => (
        <Field key={name}>
          <label htmlFor={name}>{label}</label>
          <Input id={name} maxLength={255} {...register(name)} />
          {errors[name] && <Error role="alert">{errors[name]?.message?.toString()}</Error>}
        </Field>
      ))}
    </Container>
  );
};

export default ProductInformationInput;

const Container = styled.div({ display: "flex", flexDirection: "column", gap: "2rem" });
const Title = styled.h2(({ theme }) => ({ fontSize: "1.8rem", fontWeight: theme.fontWeight.semiBold }));
const Description = styled.p(({ theme }) => ({ color: theme.color.gray, fontSize: "1.2rem", lineHeight: "1.8rem" }));
const Field = styled.div({ display: "flex", flexDirection: "column", gap: "1rem", fontSize: "1.6rem" });
const Input = styled.input(({ theme }) => ({
  width: "100%", minHeight: "5.2rem", padding: "1.6rem", fontSize: "1.4rem",
  border: `1px solid ${theme.color.light_gray}`, borderRadius: 0,
}));
const Error = styled.p(({ theme }) => ({ color: theme.color.orange, fontSize: "1.2rem" }));
